import React from 'react';
import { Layout } from '../components/Layout';
import { Showroom } from '../components/Showroom';
export function ShowroomPage() {
  return <Layout data-id="element-421">
      <div className="py-24 px-6 bg-charcoal text-alabaster" data-id="element-422">
        <div className="max-w-7xl mx-auto" data-id="element-423">
          <h1 className="text-6xl md:text-8xl font-bold mb-8" data-id="element-424">
            The{' '}
            <span className="italic font-serif font-normal text-espresso" data-id="element-425">
              Showroom
            </span>
          </h1>
          <p className="text-xl text-alabaster/60 max-w-2xl leading-relaxed" data-id="element-426">
            Explore our curated collection of door styles, finishes, and premium
            hardware. Every piece is precision-crafted to meet the highest
            standards of modern luxury.
          </p>
        </div>
      </div>
      <Showroom data-id="element-427" />
      <section className="py-24 px-6 bg-alabaster border-t-3 border-charcoal" data-id="element-428">
        <div className="max-w-7xl mx-auto" data-id="element-429">
          <h2 className="text-4xl font-bold mb-12" data-id="element-430">Premium Finishes</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-431">
            {[{
            name: 'Espresso Wood',
            image: 'https://cdn.magicpatterns.com/uploads/pEXjvtTErJLYHHVGzdMZH1/pexels-karola-g-4022121.jpg'
          }, {
            name: 'Matte Charcoal',
            image: 'https://cdn.magicpatterns.com/uploads/eAMivg3Gqj5ubm5sXciJeb/pexels-eva-bronzini-7599717.jpg'
          }, {
            name: 'Copper Brown',
            image: 'https://cdn.magicpatterns.com/uploads/3feup6JNNa1Yk6uDDpreEf/pexels-athena-1567356_(1).jpg'
          }, {
            name: 'Alabaster White',
            image: 'https://cdn.magicpatterns.com/uploads/piVdpzp8WxYkgo6Q489yTx/pexels-artbovich-7746586.jpg'
          }, {
            name: 'Midnight Oak',
            image: 'https://cdn.magicpatterns.com/uploads/89D7jsPDqRGdKWyCRFUZ1j/pexels-share-textures-3167406-11285434.jpg'
          }, {
            name: 'Natural Walnut',
            image: 'https://cdn.magicpatterns.com/uploads/cXS5gck7dhTdnhLYXD18AD/pexels-tihomir-trifonov-3106425-5225594.jpg'
          }, {
            name: 'Slate Grey',
            image: 'https://cdn.magicpatterns.com/uploads/crRVcjtAerurbP1wWaLjGU/pexels-hngstrm-7466411.jpg'
          }, {
            name: 'Classic Cream',
            image: 'https://cdn.magicpatterns.com/uploads/bfXR47xZi2aHgJ7DYFq42F/pexels-eva-bronzini-7956853.jpg'
          }].map(finish => <div key={finish.name} className="group cursor-pointer" data-id="element-432">
                <div className="aspect-square border-3 border-charcoal mb-4 overflow-hidden bg-charcoal/10" data-id="element-433">
                  {finish.image ? <img src={finish.image} alt={finish.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-434" /> : <div className="w-full h-full group-hover:bg-espresso transition-colors" data-id="element-435" />}
                </div>
                <p className="font-bold uppercase tracking-widest text-xs" data-id="element-436">
                  {finish.name}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </Layout>;
}